if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.quickView = this.dataset.quickView;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.product');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.notifyMeOnPDPVisit();
      this.sortOrderSelectOptions();
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();

      this.setImageSet();
      this.checkOmnibusPrice();
      this.checkSizeGuideButtonClone();
      this.checkSizeGuideButtonAltHTML();
    }

    sortOrderSelectOptions(){
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          var s = fieldset.querySelector('select');
          var os = Array.from(s.options);
          os.sort((a, b) => a.text.localeCompare(b.text));
          s.innerHTML = '';
          os.forEach(option => s.add(option));
        }
      });
    }

    closeDropdownExtended(){
      Array.from(this.querySelectorAll('variation-dropdown-extended')).forEach(vde => {
        vde.close();
      });
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.toggleLowStockMessage();
      this.quickViewNotifyMe();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
        this.productWrapper.classList.remove('no-variant-selected');
        this.closeDropdownExtended();
      }
      this.updateOther();

      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    manualyChangeVariant(variant_id){
      if(!variant_id) return false;
      this.currentVariant = this.getVariantData().find(variant => variant.id == Number(variant_id));
      if(!this.currentVariant) return false;

      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.fieldsets.forEach((fieldset, i) => {
        let variant_option_value = this.currentVariant['option'+(i+1)];
        if(variant_option_value){
          if (fieldset.querySelector('select')) {
            fieldset.querySelector('select').value = variant_option_value;
          } else if (fieldset.querySelectorAll('input').length) {
            fieldset.querySelector('input[value="'+ variant_option_value +'"]').checked = true;
          }
        }
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked')?.value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
        let label_sticky = document.querySelector(`.form__label--sticky-${this.dataset.section}-option-${i} .form__label__value`);
console.log('teststi',`.form__label--sticky-${this.dataset.section}-option-${i} .form__label__value`);
        if (label_sticky) {
          label_sticky.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          /* //theme code - on product.option selecting scroll to ProductSlider top
          let header_h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
          window.scrollTo({
            left: 0,
            top: (activeMedia.parentElement.offsetTop - header_h),
            behavior: 'instant'
          });
          */
          this.productWrapper.querySelector(`#Product-Slider`)?.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `data-layer-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

          var updated_payload = this.productWrapper?.querySelector('[data-item-data-layer]')?.innerHTML;
          dispatchCustomEvent('product:variant-change-datalayer', {
            payload: updated_payload ? JSON.parse(updated_payload) : {}
          });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = this.productWrapper.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
          submitButton.closest('.product-form').classList.add('product-form--sold-out');
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.closest('.product-form').classList.remove('product-form--sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    toggleLowStockMessage() {
      var low_stock_message = this.productWrapper.querySelectorAll('.product__low-stock-alert');
      if(low_stock_message.length < 1) return;
      var low_stock_ids = low_stock_message[0]?.dataset?.ids;
      if(!low_stock_ids || !this.currentVariant) return false;
      low_stock_ids = low_stock_ids.split(",").map(Number);
      if(low_stock_ids.includes(this.currentVariant.id)){
        low_stock_message.forEach(el => el.classList.remove('hidden'));
      } else {
        low_stock_message.forEach(el => el.classList.add('hidden'));
      }
    }

    quickViewNotifyMe() {
      const bis2pdp = document.querySelector(`#ProductInfo-${this.dataset.section} .bis-trigger-to-pdp`);
      if(!bis2pdp || !this.currentVariant) return false;
      if(this.currentVariant.available) return false;

      bis2pdp.setAttribute('href', `${this.dataset.url}?variant=${this.currentVariant.id}#notify-me`);
    }

    notifyMeOnPDPVisit(){
      if(window.location.hash != '#notify-me' || this.sticky || this.quickView) return false;
      const searchParams = new URLSearchParams(window.location.search);
      let new_variant_id = searchParams.get('variant');
      if(!new_variant_id) return false;
      this.manualyChangeVariant(new_variant_id);
      if(!this.currentVariant || this.currentVariant.available) return false;
      this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

      var kbis = document.querySelector(`#ProductInfo-${this.dataset.section} .klaviyo-bis-trigger`);
      setTimeout(function(){
        kbis.click();
      }, 2000);
    }

    checkOmnibusPrice(){
      if(!this.productWrapper) return false;
      const omnibusWrapper = this.productWrapper.querySelectorAll('.product-omnibus-price-value');
      if(omnibusWrapper.length < 1 || !(Shopify.currency.active && ['DKK','SEK'].includes(Shopify.currency.active))) return false;
      var val_old = parseFloat(omnibusWrapper[0].dataset.po ?? 0) * parseFloat(Shopify.currency.rate ?? 1);
      val_old = Math.round(val_old);/*DKK and SEK are rounded to whole number , not to 2nd decimal*/
      var val_now = parseFloat(omnibusWrapper[0].dataset.pn ?? 0);
      var val = Math.min(val_old, val_now);
      var diff = Math.abs(val_old - val_now); /*When small difference - take current discount price as omnibus - diff comes from rounding errors. 10 kronen is about 1eu*/
      if(val <= 0 || diff < 10) return false;
      omnibusWrapper.forEach(node => {
        node.textContent = formatMoney((val*100), (window.theme.settings.money_with_currency_format || "{{amount}}"));
      });
    }

    checkSizeGuideButtonClone(){
      if(this.quickView) return;
      let cloneTo = this.productWrapper.querySelector('.size_guide_clone');
      let cloneFrom = this.productWrapper.querySelector('modal-opener[data-modal="#PopupModal-variant_picker"]');
      if(!cloneTo || !cloneFrom) return;
      let clone = cloneFrom.cloneNode(true);
      cloneTo.replaceWith(clone);
    }

    checkSizeGuideButtonAltHTML(){
      if(this.quickView) return;
      let alt_html = this.productWrapper.querySelector('.size_guide_inner_html_alternative')?.innerHTML;
      let size_guide_button_alt = this.productWrapper.querySelector('.variation-dropdown-extended .product-popup-modal__button')
      if(!alt_html || !size_guide_button_alt) return;
      size_guide_button_alt.innerHTML = alt_html;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.hasHoverThumbs = this.classList.contains('product-images--desktop_thumbs');
      this.hasVideos = this.querySelector('[id^="Slide-"] video') !== null;

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }

      if(this.hasHoverThumbs){
        this.scene = this.parentElement.querySelector('.product-image__scene');
        if(this.scene){
          this.sceneImage = this.scene.querySelector('img');
          this.sceneVideo = this.scene.querySelector('video');

          this.sceneZoom = this.scene.querySelector('.product-single__media-zoom');
          this.sliderItems.forEach(slide => {
            slide.addEventListener('mouseenter', () => this.onThumbHover(slide));
          });
          this.sceneZoom?.addEventListener('click', (e) => {
            e.preventDefault();
            Array.from(this.sliderItems).find(item => item.classList.contains('is-active'))?.querySelector('.product-single__media-zoom')?.click();
          });
        }
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          alt: activelink.dataset.alt,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: true,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        const icon_ai = link.closest('.product-images').querySelector('.icon-ai-mod-text');

        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          document.body.classList.add('open-product-zoom');

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });

          pswp.listen('afterChange', () => {
            /*also executes when open*/
            if( pswp.currItem.alt?.toLowerCase()?.includes('|ai') ){
              const pswp_item_container = pswp.currItem && pswp.currItem.container;
              if (!pswp_item_container || !icon_ai) return;

              /*don't add twice*/
              if (pswp_item_container.querySelector('.icon-ai-mod-text')) return;

              const pswp_item_img = pswp_item_container.querySelector('.pswp__img');

              const clone = icon_ai.cloneNode(true);
              clone.classList.remove('hidden');
              pswp_item_container.appendChild(clone);

              const clone_size = clone.getBBox();
              clone.style.top = pswp_item_img.offsetHeight - clone_size.height - 20;
              clone.style.left = pswp_item_img.offsetWidth - clone_size.width - 20;
            }
          });

          pswp.listen('close', () => {
            document.body.classList.remove('open-product-zoom');
          });

          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');
      if(this.pageTotalElement){
        this.pageTotalElement.innerText = this.sliderItemsToShow.length;
      }

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      this.prevButton?.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton?.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.dots = this.pagination.querySelectorAll('.slider-counter-dot');
      this.dotsNewPage = false;
      this.dots?.forEach((dot, index) => {
        dot.addEventListener('click', () => this.onPaginationDotClick(index));
      });

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    onPaginationDotClick(index) {
      if(this.dots[index].classList.contains('current')) return;
      this.dotsNewPage = index + 1;
      const movedDelta = (this.dotsNewPage - this.currentPage);
      /*if newPage < currentPage, then movedDelta is negative. It will be substracted from scrollLeft */
      this.slideScrollPosition = this.scrollLeft + (movedDelta * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      /*if (!this.nextButton) return;*/

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        let currentElement = this.sliderItemsToShow[this.currentPage - 1];

        if(this.hasVideos){
          /*play video on scroll reached, not elements in the way*/
          clearTimeout(this.videoUpdateTimeout);
          this.videoUpdateTimeout = setTimeout(() => {
            this.updateSlideVideos(currentElement);
          }, 300);
        }

        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: currentElement
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton?.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton?.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton?.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton?.removeAttribute('disabled');
      }

      if(this.dots.length > 0){
        if(!this.dotsNewPage || (this.dotsNewPage == this.currentPage)){
          this.dots.forEach(d => d.classList.remove('current'));
          this.dots[this.currentPage - 1]?.classList.add('current');
          this.dotsNewPage = false;
        }
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
    updateSlideVideos(activeElement) {
      if (!this.hasVideos) return;

      this.sliderItems.forEach(slide => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (slide === activeElement) {
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }
    onThumbHover(slide) {
      if(slide.classList.contains('is-active')) return; /*especially to not restart video*/
      if( !window.matchMedia('(hover: hover) and (min-width: 1068px)').matches ) return;
      const new_img = slide.querySelector('img');
      const new_video = slide.querySelector('video');

      if(this.sceneVideo){
        /*null previous selected*/
        this.scene.classList.remove('video-active');
        this.sceneVideo.pause();
        this.sceneVideo.innerHTML = '';
        this.sceneVideo.removeAttribute('src');
        this.sceneVideo.load(); //also when removing
      }

      if(new_video){
        if(new_video.querySelector('source')){
          this.sceneVideo.innerHTML = new_video.innerHTML;
        }
        else {
          this.sceneVideo.src = new_video?.src ?? '';
        }
        this.sceneVideo.load();
        this.sceneVideo.play();
        this.scene.classList.add('video-active');
      }
      else if(new_img){
        this.sceneImage.src = new_img?.src ?? '';
        this.sceneImage.srcset = new_img?.srcset ?? '';
        this.sceneImage.alt = new_img?.alt ?? '';

        if(new_img.alt.toLowerCase().includes('|model') || new_img.parentElement.classList.contains('product-single__media-image--cover')){
          this.sceneImage.parentElement.classList.add('product-single__media-image--cover');
        } else {
          this.sceneImage.parentElement.classList.remove('product-single__media-image--cover');
        }

        if(new_img.alt.toLowerCase().includes('|ai')){
          this.sceneImage.parentElement.querySelector('.icon-ai-mod')?.classList.remove('hidden');
        } else {
          this.sceneImage.parentElement.querySelector('.icon-ai-mod')?.classList.add('hidden');
        }
      }
      else {
        return;
      }

      this.sliderItems.forEach(d => d.classList.remove('is-active'));
      slide.classList.add('is-active');
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.mediaHover = window.matchMedia('(hover: hover)').matches;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if(this.form.querySelector('[name=id]')){
      this.form.querySelector('[name=id]').disabled = false;
      }
      if (!this.sticky) {
        /*button in sticky triggers the same main form in PDP; the check prevents double events*/
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.productWrapper = this.closest('.product');
      this.submitButtonHolders = this.querySelectorAll('.add_to_cart_holder');

      this.hideErrors = this.dataset.hideErrors === 'true';

      /*event listener is to the upper element, because button[disabled] is with css pointer events none*/
      this.submitButtonHolders.forEach(item => {
          item.addEventListener('click', function(){
            let disabled_button = item.querySelector('button[type=submit][disabled]');
            if(!disabled_button){
              return;
            }

            if(disabled_button.classList.contains('go-to-main')){
              disabled_button = this.form.querySelector('button[type=submit]');
              disabled_button.classList.add('hover');
              this.form.closest('.product-information--inner')?.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
              });
              this.productWrapper.querySelector('variation-dropdown-extended')?.open();
            }
            else if(disabled_button.classList.contains('check-dropdown')){
                if(disabled_button.classList.contains('hover') || this.mediaHover){
                  this.productWrapper.querySelector('variation-dropdown-extended')?.open();
                }
                if(!disabled_button.classList.contains('hover')) {
                  disabled_button.classList.add('hover');
                }
            }
            else {
              this.productWrapper.classList.add('no-variant-selected');
            }
          }.bind(this));
      });

      this.VariantB2b = this.productWrapper.querySelector('variant-b2b');
      this.is_b2b = !!this.VariantB2b;
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = this.productWrapper.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch((this.is_b2b ? theme.routes.cart_update_url : theme.routes.cart_add_url), config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          var payload = this.closest('.product')?.querySelector('[data-item-data-layer]')?.innerHTML;
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
            payload: payload ? JSON.parse(payload) : {}
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer' && typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            CartDrawer.openCart();
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              CartDrawer.openCart();
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        CartDrawer.openCart();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        is_expandable = this.classList.contains('is-expandable'),
        content = this.querySelector('.product-add-to-cart-sticky--content');
if(is_expandable && button){
      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }
}

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              let footerTop = entry.boundingClientRect.top;
              let footer_threshold_passed = entry.isIntersecting && footerTop <= halfViewport;
              if (footer_threshold_passed /*entry.intersectionRatio > 0*/) {
                _this.classList.remove('sticky--visible');
                document.body.classList.remove('pdp-sticky-visible');
              } else if (!footer_threshold_passed /*entry.intersectionRatio == 0*/ && _this.formPassed) {
                _this.classList.add('sticky--visible');
                document.body.classList.add('pdp-sticky-visible');
              }
            }
            if (entry.target === top_threshold) {
              let boundingRect = top_threshold.getBoundingClientRect();
              if (/*entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)*/
                boundingRect.top < 0
              ) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
                document.body.classList.add('pdp-sticky-visible');
              } else /*if (entry.intersectionRatio === 1)*/ {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
                document.body.classList.remove('pdp-sticky-visible');
              }
            }
          });
        }, {
          threshold: [0, 0.4, 0.6, 1]
        }),
        halfViewport = window.innerHeight / 2,
        //top_threshold = document.getElementById(`product-form-${this.dataset.section}`),
        top_threshold = document.getElementById(`product-add-to-cart-sticky-top-threshold-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(top_threshold);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      if(this.drawer){
        this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
        this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      }
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        if(this.drawer){
            item.addEventListener('click', (e) => {
              this.body.classList.add('open-cc');
              this.buttons.toggleActiveClass(i);
              this.drawer.classList.add('active');
              trapFocus(this.drawer);
            });
        } else {
            item.addEventListener('mouseenter', (e) => {
              const tooltip = item.parentElement.querySelector('.side-panel-links--tooltip');
              if(!tooltip) return;
              const tooltipX = tooltip.getBoundingClientRect();
              if(tooltipX.left < 0){
                tooltip.style.transform = 'none';
                tooltip.style.left = 0;
              }
              if(tooltipX.right > window.innerWidth || tooltipX.right > document.documentElement.clientWidth){
                tooltip.style.transform = 'none';
                tooltip.style.left = 'auto';
                tooltip.style.right = 0;
              }
            });
        }
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

if (!customElements.get('variation-dropdown-extended')) {
  class VariationDropdownExtended extends HTMLElement {
    constructor() {
      super();
      this._onDocClick = (e) => {
        if (!this.contains(e.target)) {
          if(e.target.closest('.add_to_cart_holder')) return; /*not add-to-cart button (sticky bar)*/
          this.close();
        }
      };
    }
    connectedCallback() {
      this.productInfoWrapper = this.closest('.product-information--inner'); /*same like #ProductInfo-${this.dataset.section}*/

      this.heading = this.querySelector('.variation-heading-main');
      this.heading?.addEventListener('click', () => this.toggle());
      this.addEventListener('click', (e) => {
        const checkedAlreadyLabel = this.querySelector('input[type="radio"]:checked + label');
        if (!this.classList.contains('open') && e.target.closest('label')) {
          /*selector is closed - clicking on input label(it is visible when selector closed) to open*/
          this.open();
        }
        else if(this.classList.contains('open') && e.target === checkedAlreadyLabel){
          /*click on already selected input label(input disabled) to close the selector(no input change)*/
          this.close();
        }
      });

      this.querySelectorAll('.variation-alert-notify-me').forEach(btn => {
        btn.addEventListener('click', (e) => {
          var variant_option_input = e.target.closest('.variation-value').querySelector('input[type=radio]');
          var kbis = this.productInfoWrapper?.querySelector('.klaviyo-bis-trigger');
          if(!variant_option_input || !kbis) return;
          variant_option_input.checked = true;
          variant_option_input.dispatchEvent(new Event('change', { bubbles: true }));
          kbis?.click();
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
    }

    open() {
      if(this.classList.contains('open')) return;
      this.classList.add('open');
      setTimeout(() => {
        document.addEventListener('click', this._onDocClick);
      }, 0);
    }

    close() {
      this.classList.remove('open');
      document.removeEventListener('click', this._onDocClick);
      this.productInfoWrapper?.querySelectorAll('button[type=submit]').forEach(btn => btn.classList.remove('hover'));
    }

    toggle() {
      this.classList.contains('open') ? this.close() : this.open();
    }
  }

  customElements.define('variation-dropdown-extended', VariationDropdownExtended);
}

if (!customElements.get('switch-units')) {
  class SwitchUnits extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.closest('.product-popup-page-wrapper--content') || this.parentElement;
      this.tables = this.wrapper.querySelectorAll('table');
      this.buttons = this.querySelectorAll('button[data-units]');
    }

    connectedCallback() {
      this.cacheOriginalValues();
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.setUnits(btn.dataset.units));
      });
    }

    // Store the original cm values once, so repeated conversions never lose precision
    cacheOriginalValues() {
      this.tables.forEach((table) => {
        const cells = table.querySelectorAll('td');
        cells.forEach((td) => {
          const text = td.textContent.trim();
          if (/[a-zA-Z]/.test(text)) return; /* skip cols with letters like "1/2 Chest" */
          const value = parseFloat(text.replace(',', '.'));
          if (!isNaN(value) && text !== '') {
            td.dataset.cm = value;
          }
        });
      });
    }

    setUnits(unit) {
      this.tables.forEach((table) => {
        table.querySelectorAll('td[data-cm]').forEach((td) => {
          const cm = parseFloat(td.dataset.cm);
          if (cm) {
            td.textContent = (unit === 'in' ? (cm / 2.54).toFixed(1) : cm);
          }
        });
      });

      this.buttons.forEach((btn) => {
        const isActive = btn.dataset.units === unit;
        btn.classList.toggle('outline', !isActive);
        btn.setAttribute('aria-pressed', isActive);
      });
    }

  }

  customElements.define('switch-units', SwitchUnits);
}